import React from "react";
import { labelClassName } from "./classNames";

const Label = ({ htmlFor, label }) => {
  return (
    <label htmlFor={htmlFor} className={labelClassName}>
      {label}
    </label>
  );
};

export default Label;
